import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function PersonalInfo() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M16 7a4 4 0 11-8 0 4 4 0 018 0z"
        stroke={Styles.Colors.PayNew.black01}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

const PersonalInfoIcon = React.memo(PersonalInfo);

export default PersonalInfoIcon;
